import { AppTable } from 'shared/UI/UIKit/Table';
import type { SubjectWithDifficulty } from 'services/api/subject-difficulties';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';

interface SubjectDifficultiesTableProps {
  subjects: SubjectWithDifficulty[];
  loading: boolean;
  columns: AppTableColumn<SubjectWithDifficulty>[];
}

export const SubjectDifficultiesTable = ({
  subjects,
  loading,
  columns,
}: SubjectDifficultiesTableProps) => {
  return (
    <AppTable
      columns={columns}
      dataSource={subjects}
      rowKey={(record) => record.subjectId}
      loading={loading}
      scroll={{ x: 'max-content' }}
      sticky
      bordered
      size="small"
    />
  );
};
